export default __webpack_public_path__ + "static/media/robbie_gillies.6d904b0f.jpg";